import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=5dc6594c&scoped=true&"
import script from "./EmailForm.vue?vue&type=script&lang=js&"
export * from "./EmailForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=5dc6594c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc6594c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc6594c')) {
      api.createRecord('5dc6594c', component.options)
    } else {
      api.reload('5dc6594c', component.options)
    }
    module.hot.accept("./EmailForm.vue?vue&type=template&id=5dc6594c&scoped=true&", function () {
      api.rerender('5dc6594c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EmailForm.vue"
export default component.exports